export default function ToolbarButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return <button type="button" tabIndex={-1} {...props} />;
}
